import React from "react";
import he from "he";

import classes from "./Result.module.css";
import { Link } from "react-router-dom";
import { formatViews } from "../../utility";
import { connect } from "react-redux";

function Result(props) {
  return (
    <Link
      to={{
        pathname: "/watch",
        videoId: props.videoId,
        channelId: props.channelId,
        fromHome: false
      }}
    >
      <div className={classes.Result}>
        <div className={classes.Thumbnail}>
          <img src={props.imgSrc} alt="Thumbnail" />
          <span className={classes.WatchLater}>
            <i className="fas fa-clock" />
          </span>
          <span className={classes.Duration}>{props.duration}</span>
        </div>
        <div className={classes.Info}>
          <h3>{he.decode(props.title)}</h3>
          <div>
            <span className={classes.ChannelName}>{props.channelName}</span>
            <span className={classes.Dot}> . </span>
            <span
              style={{
                textTransform:
                  formatViews(props.views) === "No" ? "capitalize" : "uppercase"
              }}
            >
              {formatViews(props.views)}
            </span>{" "}
            views
            <span className={classes.Dot}> . </span>
            {props.datePublished}
          </div>
          <div className={classes.Desp}>{props.description}</div>
          <span className={["fas fa-ellipsis-v", classes.OptBtn].join(" ")} />
        </div>
      </div>
    </Link>
  );
}
const mapStateToProps = (state, props) => {
  return {
    duration:
      state.searchResults.results.items[props.index].contentDetails.duration,
    views: state.searchResults.results.items[props.index].statistics.viewCount
  };
};
export default connect(mapStateToProps)(Result);
